export default __webpack_public_path__ + "static/media/storycards_logo_trim.a9a7eb58.svg";